// allocationDateRangesStyles.js - קובץ מלא מעודכן
import { softColors } from "../../commonColors";
import { alpha } from '@mui/material';

const allocationDateRangesStyles = {
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "400px",
    gap: 2
  },
  loadingText: {
    animation: 'pulse 1.5s ease-in-out infinite',
    fontWeight: 500,
    '@keyframes pulse': {
      '0%, 100%': { opacity: 1 },
      '50%': { opacity: 0.7 }
    }
  },

  cardWithShadow: {
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06)',
    transition: 'box-shadow 0.3s ease',
    '&:hover': {
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.08)'
    }
  },

  headerBox: {
    p: 2.5,
    borderBottom: `1px solid ${alpha(softColors.border, 0.6)}`,
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: 'space-between',
    alignItems: { xs: 'stretch', md: 'center' },
    gap: 2,
    background: `linear-gradient(to bottom, ${alpha('#f8f9fa', 0.5)}, transparent)`
  },

  headerTitle: {
    fontWeight: 700,
    color: '#1e293b',
    letterSpacing: '-0.02em'
  },

 addButtonResponsive: {
  width: { xs: '100%', md: 'auto' },
  borderRadius: 2,
  textTransform: 'none',
  fontWeight: 600,
  py: 1,
  px: 3,
  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  transition: 'all 0.2s ease',
  '&:hover': {
    transform: 'translateY(-1px)',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
  }
},

  tableContainer: {
    minHeight: '300px',
    '& .MuiTable-root': {
      borderCollapse: 'separate',
      borderSpacing: '0'
    }
  },

  tableHeader: {
    backgroundColor: '#f8fafc',
    fontWeight: 700,
    fontSize: '0.875rem',
    color: '#475569',
    borderBottom: `2px solid ${softColors.border}`,
    py: 2
  },

  tableRow: {
    transition: 'all 0.2s ease',
    '&:nth-of-type(even)': {
      backgroundColor: 'rgba(248, 250, 252, 0.5)'
    },
    '&:hover': {
      backgroundColor: 'rgba(59, 130, 246, 0.05)',
      transform: 'translateX(-2px)',
      boxShadow: 'inset 3px 0 0 #3b82f6'
    }
  },

  tableCell: {
    py: 2,
    transition: 'all 0.2s ease',
    fontSize: '0.9rem',
    color: '#334155'
  },

  errorBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    py: 8,
    gap: 2
  },
  errorText: {
    fontWeight: 600,
    mb: 2
  },
  retryButton: {
    mt: 1,
    px: 4,
    py: 1.5,
    borderRadius: 2,
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
    }
  },

  emptyStateTable: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    py: 6
  },
  emptyTitle: {
    fontWeight: 600,
    mb: 1,
    color: '#64748b'
  },
  emptySubtitle: {
    fontSize: '0.875rem',
    color: '#94a3b8'
  },

  footerBox: {
    p: 2.5,
    borderTop: `1px solid ${alpha(softColors.border, 0.6)}`,
    background: `linear-gradient(to top, ${alpha('#f8f9fa', 0.8)}, transparent)`
  },

  counterText: {
    color: '#64748b',
    fontWeight: 600,
    fontSize: '0.875rem',
    textAlign: 'center',
    px: 2,
    py: 0.5,
    borderRadius: 2,
    backgroundColor: 'rgba(59, 130, 246, 0.08)',
    display: 'inline-block',
    margin: '0 auto',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: 'rgba(59, 130, 246, 0.12)'
    }
  },

  infoAlert: {
    mb: 3,
    borderRadius: 2,
    backgroundColor: alpha('#3b82f6', 0.08),
    borderLeft: `4px solid #3b82f6`,
    '& .MuiAlert-icon': {
      color: '#3b82f6'
    },
    '& .MuiAlert-message': {
      color: '#1e293b',
      fontWeight: 500
    }
  },

  errorAlert: {
    borderRadius: 2
  },

  editTextField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 1.5,
      backgroundColor: '#ffffff',
      transition: 'all 0.2s ease',
      '& fieldset': {
        borderColor: alpha('#000000', 0.12)
      },
      '&:hover fieldset': {
        borderColor: '#3b82f6',
        boxShadow: '0 2px 8px rgba(59, 130, 246, 0.15)'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#3b82f6',
        boxShadow: '0 2px 12px rgba(59, 130, 246, 0.25)'
      }
    }
  },

  actionButtons: {
    display: 'flex',
    gap: 1,
    justifyContent: 'center'
  },

  editButton: {
    color: softColors.primary,
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: alpha(softColors.primary, 0.12),
      color: softColors.primary
    }
  },

  deleteButton: {
    color: 'grey.500',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: alpha('#ef4444', 0.12),
      color: '#ef4444'
    }
  },

  saveButton: {
    color: softColors.info,
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: alpha(softColors.info, 0.12)
    }
  },

  cancelButton: {
    color: 'grey.500',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: alpha('#000000', 0.08)
    }
  },

  dialog: {
    borderRadius: '20px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
    overflow: 'hidden'
  },

  dialogTitle: {
    background: `linear-gradient(135deg, ${alpha('#ffffff', 0.95)} 0%, ${alpha('#f8f9fa', 0.95)} 100%)`,
    p: 3,
    pb: 2.5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `2px solid ${alpha('#3b82f6', 0.1)}`
  },

  dialogTitleText: {
    fontSize: '1.3rem',
    fontWeight: 700,
    color: '#1e293b',
    letterSpacing: '-0.02em'
  },

  dialogCloseButton: {
    color: '#9e9e9e',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: alpha('#f44336', 0.12),
      color: '#f44336',
      transform: 'rotate(90deg) scale(1.1)'
    }
  },

  dialogContent: {
    p: 3,
    pt: 3
  },

  dialogActions: {
    p: 3,
    gap: 2,
    borderTop: `2px solid ${alpha('#000000', 0.06)}`,
    background: `linear-gradient(to top, ${alpha('#f8f9fa', 0.5)} 0%, transparent 100%)`,
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-start'
  },

  dialogCancelButton: {
    borderRadius: 2.5,
    textTransform: 'none',
    fontWeight: 600,
    px: 3,
    py: 1,
    color: '#64748b',
    border: `1.5px solid ${alpha('#000000', 0.15)}`,
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: alpha('#000000', 0.05),
      borderColor: alpha('#000000', 0.25),
      transform: 'translateY(-1px)'
    }
  },

  dialogSubmitButton: {
    borderRadius: 2.5,
    textTransform: 'none',
    fontWeight: 700,
    px: 3,
    py: 1,
    background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
    boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
    transition: 'all 0.3s ease',
    '&:hover': {
      background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
      boxShadow: '0 6px 20px rgba(59, 130, 246, 0.4)',
      transform: 'translateY(-2px)'
    }
  },

  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    mt: 2
  },

  formField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 2.5,
      transition: 'all 0.2s ease',
      '& fieldset': {
        borderColor: alpha('#000000', 0.12)
      },
      '&:hover fieldset': {
        borderColor: '#3b82f6',
        boxShadow: '0 2px 8px rgba(59, 130, 246, 0.15)'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#3b82f6',
        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.25)'
      }
    },
    '& .MuiInputLabel-root': {
      color: '#64748b',
      fontWeight: 500,
      '&.Mui-focused': {
        color: '#3b82f6',
        fontWeight: 600
      }
    }
  }
};

export default allocationDateRangesStyles;